import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useClassesRangeCalculationDialog } from "../../../hooks/useDialogs";
import { setClassificationField, setClassificationParameter } from "../../../ducks/classification/classification";
import { getSelectedSegment } from "../../../ducks/style/selectors";
import { setValueIndex } from "../../../ducks/style/style";

export const useClassesRecalc = () => {
  const dispatch = useDispatch();
  const openClassesRangeRecalcDialog = useClassesRangeCalculationDialog();
  const selectedSegment = useSelector(getSelectedSegment);

  const calculateClassesRange = useCallback(
    ({ field, parameter, valueIndex }) => {
      if (field) {
        dispatch(setClassificationField({ field, selectedSegment }));
      }
      if (parameter) {
        dispatch(setClassificationParameter({ parameter, selectedSegment }));
      }
      if (valueIndex !== undefined) {
        dispatch(setValueIndex(valueIndex));
      }
      openClassesRangeRecalcDialog();
    },
    [dispatch, openClassesRangeRecalcDialog, selectedSegment],
  );

  return {
    calculateClassesRange,
  };
};
